import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useHankoAuth from '../hooks/useHankoAuth';
import LoadingScreen from './LoadingScreen';
import { buildLocationTarget } from '../utils/authRedirect';

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const { isAuthenticated, authChecked, isOnboarded, onboardingStatusUnavailable, loading } = useHankoAuth();

    if (loading || !authChecked) return <LoadingScreen />;

    if (!isAuthenticated) {
        return (
            <Navigate
                to="/login"
                replace
                state={{ redirectTo: buildLocationTarget(location) }}
            />
        );
    }
    if (onboardingStatusUnavailable) return <Navigate to="/status-holding" replace />;
    if (!isOnboarded) return <Navigate to="/onboarding" replace />;

    return children;
};

export default ProtectedRoute;
